import { action, makeObservable, observable } from "mobx";
import type { InjectionToken } from "tsyringe";

export interface IUIStore {
  isSearch: boolean;
  onSearchFocus: () => void;
  onSearchBlur: () => void;
}

export const UI_STORE_TOKEN = Symbol("IUIStore") as InjectionToken<IUIStore>;

export class UIStore implements IUIStore {
  private blurTimer: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    makeObservable(this);
  }

  @observable
  public isSearch: boolean = false;

  @action
  public onSearchFocus = () => {
    if (this.blurTimer) {
      clearTimeout(this.blurTimer);
      this.blurTimer = null;
    }
    this.isSearch = true;
  };

  @action
  public onSearchBlur = () => {
    if (this.blurTimer) {
      clearTimeout(this.blurTimer);
    }

    this.blurTimer = setTimeout(() => {
      this.isSearch = false;
      this.blurTimer = null;
    }, 300);
  };
}
